import React, { useEffect, useState } from "react";
import {Button, Card, Col, Container, Image, Modal, Navbar, Row } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

import logo from '../assets/img/logo.png';
import imgProdI from '../assets/img/products/01.jpg';
import imgProdII from '../assets/img/products/02.jpg';
import imgProdIII from '../assets/img/products/03.png';
import imgProdIV from '../assets/img/products/04.png';
import imgProdV from '../assets/img/products/05.png';
import imgProdVI from '../assets/img/products/06.png';
import imgProdVII from '../assets/img/products/07.png';
import imgProdVIII from '../assets/img/products/08.png';
import imgProdIX from '../assets/img/products/09.png';
import imgProdX from '../assets/img/products/10.png';

const DesignPortfolio = () => {

  const imgProducts = [
    imgProdI,
    imgProdII,
    imgProdIII,
    imgProdIV,
    imgProdV,
    imgProdVI,
    imgProdVII,
    imgProdVIII,
    imgProdIX,
    imgProdX
  ];

  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true); 
  const locPortfolio = '/portfolio/design';

  useEffect(() => {
    if (!show && location.pathname !== locPortfolio) {
      navigate(locPortfolio);
    }
  })
  
  return(
    <>
      <Navbar 
        collapseOnSelect 
        expand="lg" 
        bg="dark" 
        sticky="top" 
        className="lb-primary" 
        variant="dark" >

        <NavLink to="../../" className="navbar-brand">
          <img
            src={ logo }
            width="35"
            height="35"
            className="ms-3 d-inline-block align-top"
            alt="Logo Ginot" />
        </NavLink>
      </Navbar>

      <Container className="mt-4">
        <Row>
          { imgProducts.map((img, index) => (
            <Col lg={3} key={index} md={3} xs={6} className="mb-4">
              <Card className="w100 border-teal" bg="dark">
                <Link to={`/portfolio/design/${index}`} onClick={handleShow} >
                  <Image src={img} rounded className="w100" />
                </Link>
              </Card>
            </Col>
          )) }
        </Row>
      </Container>
      
      <Modal show={location.pathname === '/portfolio/design' ? false : true} onHide={handleClose}>
        <Button variant="dark" onClick={handleClose} className="btn-close-modal px-0 py-0 border-teal">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="#20d689" 
            viewBox="0 0 24 24">
            <g data-name="Layer 2">
              <g data-name="close">
                <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"/>
                <path d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"/>
              </g>
            </g>
          </svg>
        </Button>
          
        <Modal.Body>
          <Card bg="dark" className="w100 border-teal">
            <Card.Img variant="top" className="w100" src={imgProducts[id]} />
            <Card.Body className="text-right">
              { parseInt(id) > 0 && 
                <Link to={`/portfolio/design/${parseInt(id) - 1}`} className="btn btn-teal-outline">Préc</Link> }
              { parseInt(id) < imgProducts.length - 1 && 
                <Link to={`/portfolio/design/${parseInt(id) + 1}`} className="btn btn-teal-outline ms-2">Suiv</Link> }
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Link to="/portfolio" className="btn-fab">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 24 24">
          <g data-name="Layer 2">
            <g data-name="arrow-back">
              <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0"/>
              <path d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z"/>
            </g>
          </g>
        </svg>
      </Link>
    </>
  );
}

export default DesignPortfolio;